/**
 * Mac says ⌘, everything else says Ctrl — IBM Plex Mono has no ⌘ glyph, so elsewhere it renders
 * as tofu.
 *
 * One constant, because there were two: the help page read `navigator.userAgent` and the comment
 * composer read `navigator.platform`, which is deprecated and reports differently under some
 * browsers' privacy modes. Two sources meant the help page could promise ⌘+Enter while the box it
 * described was labelled Ctrl+Enter, on the same machine.
 */
export const MODIFIER: '⌘' | 'Ctrl' =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent) ? '⌘' : 'Ctrl'
